import React from 'react'
const Context = React.createContext()
export const { Provider, Consumer } = Context
export const withContext = (Component) => (props) => (
  <Consumer>{(value) => <Component {...props} context={value} />}</Consumer>
)
export default Context
